import PropTypes from "prop-types"
import { get, compact, isEmpty } from "lodash"
import { Button, FormControl, FormLabel, TextField, FormControlLabel, Checkbox, Autocomplete } from "@mui/material"
import { TABLE_FILTERS_SHAPE } from "components/material/table/filters/shape"

import "./styles.scss"

export default function FilterForm({ filters, setFilter, isOpPro, favoritesScreen }) {
  const TYPE_OPTIONS = compact([
    { label: "Portfolio", value: "portfolio" },
    { label: "Watchlist", value: "watchlist" },
    { label: "Basket", value: "swap" },
    !isOpPro && { label: "Research topic", value: "topic" },
  ])

  const search = get(filters, "search.value", "")
  const types = get(filters, "type.value", [])
  const favorite = get(filters, "favorite.value", false)

  return <div className="resources-table-filters">
    <form>
      <FormControl variant="standard" className="name-description">
        <FormLabel className="filter-label">Name & description</FormLabel>
        <TextField
          variant="standard"
          id="search"
          name="search"
          value={search}
          autoFocus
          placeholder="Search..."
          onChange={(e) => setFilter({ id: "search", value: e.target.value })}
        />
      </FormControl>

      <FormControl variant="standard" className="type">
        <FormLabel className="filter-label">Type</FormLabel>
        <Autocomplete
          id="type"
          name="type"
          value={types}
          onChange={(_, values) => setFilter({ id: "type", value: values })}
          multiple
          options={TYPE_OPTIONS}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
              placeholder={isEmpty(types) ? "Choose..." : null}
            />
          )}
        />
      </FormControl>

      {
        // Hide if on favorites screen, filter will be applied (but not chooseable)
        favoritesScreen ? null : <FormControl variant="standard" className="favorite">
          <FormControlLabel
            control={
              <Checkbox
                id="favorite"
                name="favorite"
                checked={favorite}
                onChange={() => setFilter({ id: "favorite", value: !favorite })}
                color="primary"
              />
            }
            label="Show favorites only"
          />
        </FormControl>
      }
    </form>
    <Button
      className="reset-filters"
      color="primary"
      onClick={() => setFilter({ action: "reset" })}
    >
      Reset filters
    </Button>
  </div>
}

FilterForm.propTypes = {
  filters: TABLE_FILTERS_SHAPE,
  setFilter: PropTypes.func.isRequired,
  isOpPro: PropTypes.bool.isRequired,
  favoritesScreen: PropTypes.bool,
}
